/* FATE policy index. Progressive enhancement: the complete document remains readable without JS. */
(() => {
  const root = document.querySelector('[data-fate-policy]');
  if (!root || root.dataset.indexReady) return;
  const body = root.querySelector('[data-policy-body]');
  const index = root.querySelector('[data-policy-index]');
  const nav = root.querySelector('[data-policy-toc]');
  if (!body || !index || !nav) return;
  const headings = [...body.querySelectorAll('h2')];
  if (!headings.length) return;
  root.dataset.indexReady = 'true';
  const fragment = document.createDocumentFragment();
  headings.forEach((heading, i) => {
    if (!heading.id) {
      const slug = heading.textContent.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      heading.id = `fate-policy-${slug || i + 1}`;
      if (document.getElementById(heading.id) !== heading) heading.id += `-${i + 1}`;
    }
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent;
    fragment.append(link);
  });
  nav.append(fragment);
  index.hidden = false;
  const desktop = matchMedia('(min-width: 1000px)');
  const adaptIndex = () => { index.open = desktop.matches; };
  adaptIndex();
  desktop.addEventListener('change', adaptIndex);
  nav.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    const heading = document.getElementById(link.hash.slice(1));
    if (heading) {
      heading.tabIndex = -1;
      requestAnimationFrame(() => heading.focus({ preventScroll: true }));
    }
  });
})();
